import React, { useEffect } from 'react';
import CartLineItem from './CartLineItem';

export default function CartDrawer({
  isOpen,
  onClose,
  cart,
  sizeConfig,
  wouldExceedCapacity,
  onIncrement,
  onDecrement,
  onRemove,
  totalCartValue,
  couponApplied,
  couponDiscount,
  finalOrderTotal,
  totalItems,
  fulfillmentLocked,
  onCheckout,
  onBrowseMenu,
}) {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen, onClose]);

  return (
    <>
      <div
        className={`cart-drawer-backdrop${isOpen ? ' cart-drawer-backdrop--open' : ''}`}
        onClick={onClose}
        aria-hidden={!isOpen}
      />
      <div
        className={`cart-drawer${isOpen ? ' cart-drawer--open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Your cart"
      >
        <div className="cart-drawer__header">
          <h2 className="cart-drawer__title">Your Cart</h2>
          <button onClick={onClose} className="cart-drawer__close" aria-label="Close cart">✕</button>
        </div>

        {cart.length === 0 ? (
          <div className="cart-drawer__empty">
            <p className="cart-drawer__empty-text">Your cart is empty</p>
            <button onClick={onBrowseMenu} className="btn-primary">Browse Menu</button>
          </div>
        ) : (
          <>
            <div className="cart-drawer__items">
              {cart.map(item => {
                const step = sizeConfig[item.size]?.step || 1;
                const itemIsBlocked = wouldExceedCapacity(item.size, step);
                return (
                  <CartLineItem
                    key={item.id}
                    item={item}
                    onIncrement={onIncrement}
                    onDecrement={onDecrement}
                    onRemove={onRemove}
                    atCapacity={itemIsBlocked}
                  />
                );
              })}
            </div>

            <div className="cart-drawer__footer">
              <div className="cart-subtotal-row">
                <span>Subtotal</span><span>${totalCartValue.toFixed(2)}</span>
              </div>
              {couponApplied && (
                <>
                  <div className="coupon-discount-row">
                    <span>{couponApplied}</span><span>−${couponDiscount.toFixed(2)}</span>
                  </div>
                  <div className="total-row">
                    <span>Total</span><span>${finalOrderTotal.toFixed(2)}</span>
                  </div>
                </>
              )}
              <button onClick={onCheckout} className="btn-primary cart-drawer__checkout-btn">
                ({totalItems}) {fulfillmentLocked ? 'Review Order' : 'Checkout'} →
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}